import { Injectable } from '@angular/core';
import { UserService } from '@core/services/user.service';
import { BcmUserPermission } from '../bcm-user-permission';
import { getBcmCapabilityDefinition } from './bcm-capabilities.registry';

@Injectable({ providedIn: 'root' })
export class BcmCapabilityService {

    constructor(private _userService: UserService) {
    }

    /**
     * Ob ein optionaler Prefetch/API-Call gestartet werden soll.
     * Unbekannte capabilityId → true (Legacy, fail-open).
     */
    shouldPrefetch(capabilityId: string): boolean {
        const definition = getBcmCapabilityDefinition(capabilityId);

        if (!definition) {
            return true;
        }

        if (!definition.permissionsAny.length) {
            return false;
        }

        return this._userService.hasOnePermissionOf(...definition.permissionsAny);
    }

    hasAnyPermission(...permissions: BcmUserPermission[]): boolean {
        return this._userService.hasOnePermissionOf(...permissions);
    }
}
